import { render, staticRenderFns } from "./CheckboxesAction.vue?vue&type=template&id=6d5d53c6&scoped=true&"
import script from "./CheckboxesAction.vue?vue&type=script&lang=js&"
export * from "./CheckboxesAction.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesAction.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CheckboxesAction.vue?vue&type=style&index=1&id=6d5d53c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d53c6",
  null
  
)

export default component.exports